// extracted by mini-css-extract-plugin
export default {"hotels":"hotels_hotels__kBcWK","swiper-wrapper":"hotels_swiper-wrapper__-8bao"};